function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { LocationFilterManager } from './LocationFilterManager';
import LocationSortingManager from './LocationSortingManager';

var LocationManager = /*#__PURE__*/function () {
  function LocationManager() {
    _classCallCheck(this, LocationManager);

    /**
     * @type {LocationFilterManager}
     * @private
     */
    this.filterManager = new LocationFilterManager();
    this.sortingManager = new LocationSortingManager();
  }
  /**
   * @param {Location[]} locations
   * @param {Location} targetLocation
   */


  _createClass(LocationManager, [{
    key: "sort",
    value: function sort(locations, targetLocation) {
      var _this = this;

      var filteredLocations = locations.filter(function (location) {
        return _this.filterManager.compare(location);
      });
      return this.sortingManager.sort(filteredLocations, targetLocation);
    }
  }, {
    key: "addFilter",
    value: function addFilter(filter) {
      this.filterManager.addFilter(filter);
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      this.filterManager.removeFilter(filter);
    }
  }]);

  return LocationManager;
}();

export default LocationManager;